
// One sidebar section switch of the summary. In the AEP builder every switch
// is set automatically (spec §9); a manual toggle shows "manual · reset".
export default {
    props: {
        text: { type: String, default: '' },
        value: { type: [String, Number], default: null },
        checked: { type: Boolean, default: false },
        manual: { type: Boolean, default: false },
        showTag: { type: Boolean, default: false },
    },
}
